import React, { forwardRef, useState, useEffect, useRef, useCallback } from 'react';
import './Testimonials.css';
import TestimonialCard from './TestimonialCard'; // Import the new TestimonialCard component

const Testimonials = forwardRef((props, ref) => {
  const testimonialsData = [
    {
      name: 'John Doe',
      rating: 5,
      review: 'MegaVolt Electric provided excellent service! Highly recommend them for any electrical needs.',
      image: '/images/profile_images/john_doe.png' // Updated image path
    },
    {
      name: 'Jane Smith',
      rating: 4,
      review: 'Professional and efficient. They fixed our wiring issue quickly and effectively.',
      image: '/images/profile_images/jane_smith.png' // Updated image path
    },
    {
      name: 'Peter Jones',
      rating: 5,
      review: 'Fantastic work! The team was friendly and the quality of work was outstanding.',
      image: '/images/profile_images/peter_jones.png' // Updated image path
    },
    {
      name: 'Sarah Brown',
      rating: 5,
      review: 'Reliable and trustworthy. I\'m very happy with the electrical upgrade they performed.',
      image: '/images/profile_images/sarah_brown.png' // Updated image path
    },
    {
      name: 'Michael Green',
      rating: 5,
      review: 'Quick response and fair pricing. MegaVolt Electric is my go-to for all electrical work.',
      image: '/images/profile_images/michael_green.png' // Updated image path
    },
    {
      name: 'Emily White',
      rating: 4,
      review: 'They installed new lighting in our kitchen and it looks amazing! Very happy with the result.',
      image: '/images/profile_images/emily_white.png' // Updated image path
    },
    {
      name: 'David Black',
      rating: 5,
      review: 'Exceptional service from start to finish. Highly professional and skilled electricians.',
      image: '/images/profile_images/david_black.png' // Updated image path
    },
    {
      name: 'Jessica Blue',
      rating: 4,
      review: 'Had a power outage issue, and they came out quickly and resolved it. Great service!',
      image: '/images/profile_images/jessica_blue.png' // Updated image path
    },
    {
      name: 'Chris Red',
      rating: 5,
      review: 'The best electricians in Calgary! Always on time and do a thorough job.',
      image: '/images/profile_images/chris_red.png' // Updated image path
    },
    {
      name: 'Laura Grey',
      rating: 4,
      review: 'Very knowledgeable and friendly. They explained everything clearly.',
      image: '/images/profile_images/laura_grey.png' // Updated image path
    },
    {
      name: 'Paul Orange',
      rating: 5,
      review: 'Installed our EV charger perfectly. Highly recommend their expertise.',
      image: '/images/profile_images/paul_orange.png' // Updated image path
    },
    {
      name: 'Olivia Pink',
      rating: 5,
      review: 'Responsive and professional. Fixed a complex electrical problem with ease.',
      image: '/images/profile_images/olivia_pink.png' // Updated image path
    },
  ];

  const numberOfCards = 4; // Number of testimonial cards to display
  const [cardReviewIndices, setCardReviewIndices] = useState([]);
  const availableReviewIndicesRef = useRef([]);

  // Initialize available reviews and assign initial reviews to cards
  useEffect(() => {
    const allIndices = Array.from({ length: testimonialsData.length }, (_, i) => i);
    // Shuffle all indices to ensure random initial assignment
    for (let i = allIndices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [allIndices[i], allIndices[j]] = [allIndices[j], allIndices[i]];
    }

    const initialCardIndices = allIndices.splice(0, numberOfCards);
    availableReviewIndicesRef.current = allIndices; // Remaining indices are available
    setCardReviewIndices(initialCardIndices);
  }, [testimonialsData.length]);

  // Function to get a new unique review index
  const getNewUniqueReviewIndex = useCallback((oldIndex) => {
    // Add the old index back to the available pool
    if (oldIndex !== undefined && oldIndex !== null) {
      availableReviewIndicesRef.current.push(oldIndex);
    }

    // If no available reviews, it means all are currently displayed or there aren't enough unique reviews
    if (availableReviewIndicesRef.current.length === 0) {
      // This scenario should ideally not happen if testimonialsData.length > numberOfCards
      // For robustness, we can re-use an old one, but this would break uniqueness.
      // A better approach would be to wait or throw an error.
      // For now, let's assume testimonialsData.length > numberOfCards
      console.warn("Not enough unique testimonials for the number of cards. Duplicates might occur.");
      return oldIndex; // Return the old index to prevent a crash, but this is a duplicate
    }

    // Pick a random new index from the available pool
    const randomIndex = Math.floor(Math.random() * availableReviewIndicesRef.current.length);
    const newIndex = availableReviewIndicesRef.current.splice(randomIndex, 1)[0];

    return newIndex;
  }, []);

  // Callback for TestimonialCard to request a new review
  const handleReviewChange = useCallback((cardDisplayIndex, oldReviewIndex) => {
    const newReviewIndex = getNewUniqueReviewIndex(oldReviewIndex);

    setCardReviewIndices(prevIndices => {
      const updatedIndices = [...prevIndices];
      updatedIndices[cardDisplayIndex] = newReviewIndex;
      return updatedIndices;
    });
  }, [getNewUniqueReviewIndex]);

  return (
    <section ref={ref} className="testimonials-section">
      <h2>Customer Testimonials</h2>
      <div className="testimonials-container">
        {cardReviewIndices.map((reviewIndex, index) => (
          <TestimonialCard
            key={index}
            testimonial={testimonialsData[reviewIndex]}
            onReviewChange={(oldReviewIndex) => handleReviewChange(index, oldReviewIndex)}
            initialReviewIndex={reviewIndex} // Pass initial index for TestimonialCard to manage
          />
        ))}
      </div>
    </section>
  );
});

export default Testimonials;

